import React from 'react'

import { Collection, Group } from '../details/collection'
import { Details, Row, Block } from '../details/details'
import DateTimePicker from '../../components/forms/datetime-picker.js'
import { CollectionButton } from '../buttons'

import InspectionCard from './inspection-card'
import SelectAreaContainer from '../../containers/inspections/select-area-container'
import SelectInspectorContainer from '../../containers/inspections/select-inspector-container'

class InspectionsList extends React.PureComponent {
  nextPageButton () {
    if (this.props.hasNextPage) {
      return <CollectionButton onClick={this.props.onLoadNextPage}>See more...</CollectionButton>
    }
  }

  render () {
    const {
      inspections,
      applyFilters,
      onSetInspectionFilters,

      startDate,
      endDate,
      areaId,
      inspectorId,
    } = this.props

    return (
      <div className="location-inspections-list">
        <Details>
          <Row>
            <Block title='Area'>
              <SelectAreaContainer
                locationId={this.props.params.locationId}
                value={areaId}
                onChange={option => {
                  onSetInspectionFilters('areaId', (option || {}).value)
                }}
              />
            </Block>
            <Block title='Inspector'>
              <SelectInspectorContainer
                locationId={this.props.params.locationId}
                value={inspectorId}
                onChange={option => {
                  onSetInspectionFilters('inspectorId', (option || {}).value)
                }}
              />
            </Block>
          </Row>
          <Row>
            <Block title="Start date" className="modal-form-block">
              <DateTimePicker value={startDate} onChange={value => onSetInspectionFilters('startDate', value)} />
            </Block>
            <Block title="End Date">
              <DateTimePicker value={endDate} onChange={value => onSetInspectionFilters('endDate', value)} />
            </Block>
          </Row>
        </Details>

        <Collection>
          {inspections.map(inspection => (
            <InspectionCard key={inspection.id} {...inspection} />
          ))}

          {this.nextPageButton()}
        </Collection>
      </div>
    )
  }
}

export default InspectionsList



// WEBPACK FOOTER //
// ./src/components/inspections/inspections.js